import {prependRoot} from "../util/prependRoot.js";
import {getApiRoot} from "../store/configureStore.js";
import axios from "axios";

const routePrefix = "/geography/";

const GeographyApi = {
	getCoordinatenForAdres(adres) {
		const serviceUrl = prependRoot(routePrefix, getApiRoot());
		return axios.post(serviceUrl, adres, {
			headers: {
				'accept': 'application/json'
			}
		});
	}
};

export default GeographyApi;
